var XPortal = XPortal || {};
XPortal.ImportData = (function () {
    var self = {
        batchInProgress: false,
        modalSelector: "#gridActionsModalBox",
        InitImportDataPopup: function (options) {
            if (!options.uploadUrl || !options.processBatchUrl || !options.finalizeBatchUrl || !options.finalizeImportUrl)
                return console.log("import data configuration issue:", options);
            options.validateRecordsUpfront = false;
            options.skipGridFromPipeLine = true;
            options.modalSelector = options.modalSelector || self.modalSelector;
            loadLocalizationMessages().then(function () {
                XPortal.Modal.prepareModalFromTemplate($(options.importDataTemplate), true, function () {
                    options.cancelledByUser = true;
                    $(options.modalSelector).removeAttr('data-step');
                    cleanUpGrid(options);
                }, null, {
                    beforeRender: function (el, stgs) {
                        options.modalSelector = stgs.modalSelector || options.modalSelector;
                        var bcontent = el.find('.modal-body').find(".modal-body-footer");
                        var widthClases = 'col-12';
                        bcontent.detach();
                        el.find('.modal-footer').html('');
                        bcontent.appendTo(el.find('.modal-footer'));
                        if (options.settings.width == widthClases) {
                            widthClases = 'col-default-width';
                        } else {
                            widthClases = options.settings.width;
                        }
                        el.find(".modal-content").addClass(widthClases).addClass("custom-popup-width");
                    }
                });
                setTimeout(function () { initReportGrid(options, $(options.modalSelector)); }, 1);
                self.HideAllSteps(options);
                self.ShowImportDataStep1(options);
                $(options.modalSelector).find(".import-close").off("click").on("click", function (e) {
                    e.preventDefault();
                    XPortal.Modal.closeModal(null, options.modalSelector);
                });
            });
        },
        HideAllSteps: function (options, showSelector, container) {
            container = container || $(options.modalSelector);
            container.find(".import-data-step").each(function () {
                $(this).hide();
            });
            if (showSelector) container.find(showSelector).show();
        },
        ShowImportDataStep1: function (options) {
            var importContainer = $(options.modalSelector);
            importContainer.attr('data-step', 1);
            var fileEl = importContainer.find(".import-data-step1").find("input[name='filesToImport']");
            var title = $('.import-data-step1-title').text();
            $(options.modalSelector).find('.modal-header-cnt').html(`<h4 class="modal-title">${title}</h4>`)

            var upload = fileEl.data("kendoUpload");
            if (upload) upload.destroy();

            var validation = {};
            if (options.maxUploadSize) validation.maxFileSize = options.maxUploadSize;
            validation.allowedExtensions = options.fileTypes;
            fileEl.kendoUpload({
                async: { saveUrl: options.uploadUrl, autoUpload: true }, multiple: false, validation: validation,
                localization: {
                    clearSelectedFiles: options.texts.fileuploadclear,
                    uploadSelectedFiles: options.texts.fileuploadupload,
                    dropFilesHere: options.texts.fileuploaddrop,
                    headerStatusUploaded: options.texts.fileuploadstatusuploaded,
                    headerStatusUploading: options.texts.fileuploadstatusuploading,
                    select: options.texts.fileuploadselectlear
                },
                upload: function (e) {
                    updateImportSate(options, { level: 1, type: "uploadfile.start", data: options });

                    e.data = { batchSize: options.batchSize };
                },
                success: function (e) {
                    if (e.response && e.response.IsError) return XPortal.Modal.alert({ headerText: e.response.Title, alertText: e.response.Message });
                    var data = ensureImportResponse(options, e.response);
                    self.ShowImportDataStep2(options, data);
                },
                error: function (e) {
                    const rtext = e.XMLHttpRequest.responseText;
                    var errorInfo = rtext ? JSON.parse(rtext) : "";
                    updateImportSate(options, { level: 1, type: "uploadfile.error", data: { error: errorInfo } });
                    if (errorInfo && errorInfo.IsError) return XPortal.Modal.alert({ headerText: errorInfo.Title, alertText: errorInfo.Message });
                }
            }).data("kendoUpload");
            self.HideAllSteps(options, ".import-data-step1");
        },
        ShowImportDataStep2: function (options, uploadDetails) {
            var importContainer = $(options.modalSelector);
            importContainer.attr('data-step', 2);
            var stepContainer = importContainer.find(".import-data-step2");
            options.importDataId = uploadDetails.ImportDataId;
            options.totalRowsCount = uploadDetails.TotalRowsCount;
            options.totalBatchCount = Math.ceil(options.totalRowsCount / options.batchSize);
            options.duplicates = uploadDetails.Duplicates || [];
            var title = $('.import-data-step2-title').text();
            $(options.modalSelector).find('.modal-header-cnt').html(`<h4 class="modal-title">${title}</h4>`)

            var descriptionTemplate = importContainer.find(".import-data-step2-description");

            if (descriptionTemplate.length > 0) {
                var values = {
                    rowscount: options.totalRowsCount,
                    batchcount: options.totalBatchCount,
                    batchsize: options.batchSize,
                    fields: uploadDetails.FieldsToProcess.join(", "),
                    duplicates: options.duplicates
                };
                var formattedHtml = XPortal.Template.ReplaceFormatString(descriptionTemplate.text(), null, values);
                var templateHtml = XPortal.Template.ApplyKendoTemplate(values, formattedHtml);
                descriptionTemplate.html(templateHtml);
            }

            updateImportSate(options, { level: 1, type: "uploadfile.completed", data: options });
            var continueButton = stepContainer.find("button.import-continue");
            continueButton.off("click.import-continue").on("click.import-continue", function (e) {
                e.preventDefault();
                options.startDate = new Date();
                options.processedBatchIndex = 0;
                var importDataOption = $("input[name='importDataOptions']:checked", stepContainer).val();
                options.stopOnError = importDataOption === "stop";
                self.ShowImportDataStep3(options);
            });
            self.HideAllSteps(options, ".import-data-step2");
        },
        ShowImportDataStep3: function (options) {
            var importContainer = $(options.modalSelector);
            importContainer.attr('data-step', 3);
            var stepContainer = importContainer.find(".import-data-step3");
            var progress = stepContainer.find(".import-data-step3-progress");
            options.progress = progress;
            self.UpdateLoaderWithApproximateTime(options.progress, options.startDate, options.totalBatchCount, options.processedBatchIndex, options.texts);
            var cancelButton = stepContainer.find("button.import-cancel");
            var title = $('.import-data-step3-title').text();
            $(options.modalSelector).find('.modal-header-cnt').html(`<h4 class="modal-title">${title}</h4>`)
            cancelButton.off("click.import-cancel").on("click.import-cancel", function (e) {
                e.preventDefault();
                options.cancelledByUser = true;
                cancelButton.attr("disabled", true);
                var cancellingTitle = cancelButton.attr("data-cancelling-title");
                cancelButton.html(cancellingTitle);
                if (!self.batchInProgress) self.ShowImportDataSummary(options);
            });
            self.HideAllSteps(options, ".import-data-step3");
            try {
                XPortal.Grid.SuspendGridRefresh(options.grid);
                self.StartNextBatch(options, 0);
            } catch (ex) {
                XPortal.Grid.ResumeGridRefresh(options.grid);
                throw ex;
            }
        },
        ShowImportDataSummary: function (options) {
            var importContainer = $(options.modalSelector);
            importContainer.attr('data-step', 4);
            var stepContainer = importContainer.find(".import-data-summary");
            stepContainer.find(".import-report-hide").addClass("d-none").hide();
            var title = $('.import-data-summary-title').text();
            $(options.modalSelector).find('.modal-header-cnt').html(`<h4 class="modal-title">${title}</h4>`)
            if (!options.reportGrid) stepContainer.find(".import-report").hide();
            else {
                stepContainer.on("click", ".import-report", function (e) {
                    importContainer.attr('data-step', 5);
                    e.preventDefault();
                    ShowReportGrid(stepContainer, options);
                });
                stepContainer.on("click", ".import-report-hide", function (e) {
                    importContainer.attr('data-step', 4);
                    e.preventDefault();
                    stepContainer.find(".import-report-hide").addClass("d-none").hide();
                    stepContainer.find(".import-report").removeClass("d-none").show();
                    stepContainer.find(".import-data-summary-short").removeClass("d-none").show();
                    stepContainer.find(".rprt-grid-container").hide().addClass("d-none");
                });
            }
            self.FinalizeImport(options).then(function (response) {
                var descriptionTemplate = importContainer.find(".import-data-summary-description");
                if (descriptionTemplate.length > 0) {
                    var totalTimeSpentInSeconds = (new Date() - options.startDate) / 1000;
                    var spentHours = Math.floor(totalTimeSpentInSeconds / 3600);
                    var spentMinutes = Math.floor(totalTimeSpentInSeconds / 60) - (spentHours * 60);
                    var spentSeconds = Math.ceil(totalTimeSpentInSeconds) - (spentHours * 3600) - (spentMinutes * 60);
                    var timeSpentTemplate = XPortal.Template.ReplaceFormatString(options.texts.timespenttemplate, null, { hours: spentHours, minutes: spentMinutes, seconds: spentSeconds });

                    descriptionTemplate.html(XPortal.Template.ReplaceFormatString(descriptionTemplate.html(), null, {
                        totalrowscount: response.TotalRowsCount,
                        processedrowscount: response.ProcessedRowsCount,
                        newrowscount: response.NewRowsCount,
                        updatedrowscount: response.UpdatedRowsCount,
                        failedrowscount: response.FailedRowsCount,
                        timespent: timeSpentTemplate
                    }));

                    var reportTemplate = importContainer.find(".import-data-summary-report");
                    reportTemplate.hide();
                    if (response.FailedRowsCount > 0 && options.reportUrl && options.reportUrl.length > 0) {
                        var reportUrl = options.reportUrl.replace("IMPORTDATAID", encodeURIComponent(options.importDataId));
                        var reportFormattedHtml = XPortal.Template.ReplaceFormatString(reportTemplate.html(), null, { reporturl: reportUrl });
                        reportTemplate.html(reportFormattedHtml);
                        reportTemplate.show();
                    }
                }
                self.HideAllSteps(options, ".import-data-summary");
                cleanUpGrid(options, importContainer);
                XPortal.Grid.ResumeGridRefresh(options.grid);
            })
                .catch(function () {
                    XPortal.Modal.alert({ headerText: options.texts.errortitle, alertText: options.texts.generalerror });
                    cleanUpGrid(options, importContainer);
                    XPortal.Grid.ResumeGridRefresh(options.grid);
                });
        },
        UpdateLoaderWithApproximateTime: function (placeHolder, startDate, totalBatchCount, processedBatchCount, texts) {
            var diffsec = (new Date() - startDate) / 1000;
            var percentComplete = (processedBatchCount / totalBatchCount) * 100;
            var data = { percentcomplete: Math.ceil(percentComplete), timeleft: "", totalseconds: 0, minutes: 0, seconds: 0 };
            if (percentComplete > 0) {
                data.totalseconds = Math.max((100 * diffsec) / percentComplete - diffsec, 0);
                data.minutes = Math.floor(data.totalseconds / 60);
                data.seconds = Math.ceil((data.minutes - Math.floor(data.minutes)) * 60);
                data.timeleft = XPortal.Template.ReplaceFormatString(texts.progresstimeleft, null, data);
            }
            var loaderText = XPortal.Template.ReplaceFormatString(texts.progresstext, null, data);
            var loaderMessage = XPortal.Template.ReplaceFormatString(texts.progresstooltip, null, data);
            XPortal.Loader.message({ "selector": placeHolder, showOverlay: false }, loaderText, loaderMessage);
        },
        StartNextBatch: function (options, nextBatchIndex) {
            if (self.batchInProgress || options.cancelledByUser) return;
            if (options.totalBatchCount === nextBatchIndex) self.ShowImportDataSummary(options);
            else self.ProcessBatch(options, nextBatchIndex);
        },
        ProcessBatch: function (options, batchIndex) {
            if (self.batchInProgress || options.cancelledByUser) return;
            self.batchInProgress = true;
            var postData = { importDataId: options.importDataId, batchIndex: batchIndex, stopOnError: options.stopOnError ? true : false, Duplicates: options.duplicates };
            updateImportSate(options, { level: 1, type: "process.batch.start", data: { index: batchIndex + 1 } });

            XPortal.Utils.APIPost(options.processBatchUrl, postData)
                .then(function (response) { self.HandleBatchSuccess(options, batchIndex, response); })
                .fail(function (xhr) { self.HandleBatchError(options, batchIndex, xhr); });

        },
        FinalizeBatch: function (options, batchIndex, context) {
            return new Promise(function (onOk, onError) {
                if (self.batchInProgress || options.cancelledByUser) return setTimeout(function () { onOk(context); }, 1);
                var postData = { ImportDataId: options.importDataId, BatchIndex: batchIndex, EntitiesToFinalize: context.EntitiesToFinalize, EntitiesWithErrors: context.EntitiesWithErrors };
                updateImportSate(options, { level: 1, type: "process.batch.finalizing", data: { index: batchIndex + 1 } });
                XPortal.Utils.APIPost(options.finalizeBatchUrl, postData)
                    .then(function (response) {
                        onOk(context);
                    })
                    .fail(function (xhr) {
                        var errorInfo = xhr.status !== 400 ? { Title: options.texts.errortitle, Message: options.texts.generalbatcherror } : JSON.parse(xhr.responseText);
                        console.error("Error occured during batch finalization. Batch index is '" + options.processedBatchIndex + "', status code is '" + xhr.status + "', error message is '" + errorInfo.Message + "'.");
                        onError(context);
                    });
            });
        },
        FinalizeImport: function (options) {
            if (self.batchInProgress) {
                return Promise.reject();
            }

            var postData = { importDataId: options.importDataId };
            return XPortal.Utils.APIPost(options.finalizeImportUrl, postData)
                .fail(function (xhr) {
                    console.error("Error occured during import finalization. Status code is '" + xhr.status + "', error message is '" + xhr.statusText + "'.");
                });
        },
        HandleBatchSuccess: function (options, batchIndex, response) {
            self.batchInProgress = false;
            options.processedBatchIndex = batchIndex;
            if (options.cancelledByUser) return self.CancelImportData(options);
            if (response.IsError) {
                updateImportSate(options, { level: 1, type: "process.batch.error", data: { index: batchIndex + 1, error: response.Message } });
                console.warn("Error occured during batch processing. Batch index is '" + batchIndex + "', status code is '200', error message is '" + response.Message + "'.");
                //XPortal.Modal.alert({ headerText: response.Title, alertText: response.Message });
                return self.ShowImportDataSummary(options);
            }
            var nextBatchIndex = options.processedBatchIndex + 1;
            self.UpdateLoaderWithApproximateTime(options.progress, options.startDate, options.totalBatchCount, nextBatchIndex, options.texts);

            setTimeout(async function () {
                var respEntities = response.Entities;
                var context = await self.UpdateGrid(options, respEntities);
                setDuplicatesErrors(response, respEntities, context);
                await self.FinalizeBatch(options, batchIndex, context);
                if ((!context.isValid || response.FailedRowsCount > 0) && options.stopOnError) self.ShowImportDataSummary(options);
                else self.StartNextBatch(options, nextBatchIndex);
            }, 1);
        },
        HandleBatchError: function (options, batchIndex, xhr) {
            self.batchInProgress = false;
            var errorInfo = xhr.status !== 400
                ? { Title: options.texts.errortitle, Message: options.texts.generalbatcherror }
                : JSON.parse(xhr.responseText);
            updateImportSate(options, { level: 1, type: "process.batch.error", data: { index: batchIndex + 1, error: errorInfo.Message } });
            console.error("Error occured during batch processing. Batch index is '" + batchIndex + "', status code is '" + xhr.status + "', error message is '" + errorInfo.Message + "'.");
            console.error("batch processing error reason: options.cancelledByUser?'" + options.cancelledByUser + "', stopOnError?'" + options.stopOnError + "'.");
            if (options.cancelledByUser) return self.CancelImportData(options);
            if (options.stopOnError) self.ShowImportDataSummary(options);
            else {
                console.error("continue with records processing, even error:");
                options.processedBatchIndex = batchIndex;
                var nextBatchIndex = options.processedBatchIndex + 1;
                self.UpdateLoaderWithApproximateTime(options.progress, options.startDate, options.totalBatchCount, nextBatchIndex, options.texts);
                self.StartNextBatch(options, nextBatchIndex);
            }
        },
        CancelImportData: function (options) {
            self.ShowImportDataSummary(options);
        },
        UpdateGrid: function (options, entities) {
            return new Promise(async function (onOk) {
                var model = cleanUpGridBeforeUpdate(options, entities);
                var result = { isValid: true, entities, insert: null, events: null, save: null, errors: null };
                var final = function () { setTimeout(function () { onOk(updateGridProcessingState(result)); }, 1); };

                await insertGridRows(options, result, model);
                if (!result.isValid || options.cancelledByUser) return final();
                await processClientEvents(options, result, model);
                if (!result.isValid || options.cancelledByUser) return final();
                await saveProcessedRecords(options, result, model);
                result.isValid = result.save.isValid;
                return final();
            });
        },
        TriggerClientEventsForRow: function (modelName, preparedEntity, editableColumns) {
            editableColumns.forEach(function (column) {
                var fieldName = column.attributes["data-cfield"].toLowerCase();
                var field = preparedEntity.Fields.find(f => f.Name.toLowerCase() === fieldName);
                var fieldEventData = { field: fieldName, ftype: field.Type, data: field.StringValue };
                XPortal.Store.DispatchFieldEvent(XPortal.Redusers.ACTIONS.EDIT_FIELD, fieldEventData, modelName, true, true);
            });
        },
    }

    function setDuplicatesErrors(response, respEntities, context) {
        var duplicates = response.Duplicates;
        if (duplicates.length > 0) {
            for (var i = 0; i < duplicates.length; i++) {
                context.EntitiesWithErrors.push({
                    Errors: [{ Field: duplicates[i].Value, Error: "duplicate" }],
                    RowIndex: duplicates[i].LineNumber,
                    UniqueId: duplicates[i].UniqueId
                });
            }
        }
    }
    function insertGridRows(options, context) {
        var entities = context.entities;
        context.insert = { isValid: true, entities: [], errors: [], errorsAmount: 0 };
        return new Promise(async function (onOk) {
            var kgrid = options.grid.data("kendoGrid");

            var executeNextItem = function (k) {
                var preparedEntity = k < entities.length ? XPortal.Grid.MapEntity(entities[k]) : null;
                updateImportSate(options, { level: 3, type: "insertrow", data: { index: k + 1, batchindex: options.processedBatchIndex + 1, entity: preparedEntity } });
                return new Promise(function (itemOnOk) {
                    if (preparedEntity == null) return itemOnOk(false);
                    try {
                        preparedEntity.IsCreating = false;
                        preparedEntity._newInlineRecord = false;
                        if (!options.skipGridFromPipeLine) kgrid.dataSource.add(preparedEntity);
                        if (options.validateRecordsUpfront) {
                            updateImportSate(options, { level: 3, type: "validaterow", data: { index: k + 1, batchindex: options.processedBatchIndex + 1, entity: preparedEntity } });
                            validateEntity(options, preparedEntity, context, context.insert, k);
                            return k % 20 ? setTimeout(function () { itemOnOk(false); }, 1) : itemOnOk(false);
                        }
                        context.insert.entities.push(preparedEntity);
                    } catch (ex) {
                        context.insert.isValid = false;
                        context.insert.errorsAmount = context.insert.errorsAmount + 1;
                        updateImportSate(options, { level: 3, type: "insertrow.error", data: { index: k + 1, batchindex: options.processedBatchIndex + 1, entity: preparedEntity } });
                        log(1, "" + k + ". Can't insert grid rows, error:", { ex, k });
                    }
                    return k % 20 ? setTimeout(function () { itemOnOk(context.insert.isValid); }, 1) : itemOnOk(context.insert.isValid);
                });
            };
            setTimeout(async function () {
                updateImportSate(options, { level: 2, type: "insertrows.start", data: { index: options.processedBatchIndex + 1, amount: (entities || []).length } });
                var dataExists = true;
                var i = 0;
                while (dataExists) {
                    dataExists = await executeNextItem(i);
                    i++;
                }
                updateImportSate(options, { level: 2, type: "insertrows.completed", data: { index: options.processedBatchIndex + 1, amount: context.insert.entities.length, errors: context.insert.errorsAmount } });
                context.isValid = context.insert.isValid;
                onOk(context);
            }, 1);
        });
    };
    function processClientEvents(options, context, model) {
        var kgrid = options.grid.data("kendoGrid");
        var modelName = XPortal.Store.getGridModelName(options.grid.attr("id"));
        var entities = kgrid.dataSource.data();
        context.events = { isValid: true, entities: [], errors: [], errorsAmount: 0 };
        var processed = [];
        return new Promise(function (onOk) {
            updateImportSate(options, { level: 2, type: "exec.clientevents.start", data: { index: options.processedBatchIndex + 1, amount: (entities || []).length } });
            var i = 0;
            XPortal.Store.ProcessEntitiesSynchronously(function () {
                var item = getNextDistincEntity(entities, processed);
                i++;
                if (!item) return new Promise(function (ok) { ok(item); });
                updateImportSate(options, { level: 3, type: "exec.clientevents.row", data: { index: i + 1, batchindex: options.processedBatchIndex + 1, entity: item } });
                context.events.entities.push(item);
                return new Promise((r) => {
                    var editableColumns = kgrid.columns.filter(col => (col && col.headerAttributes && col.attributes['data-ctype'] !== "calendarcolumn" && col.editable(item)));
                    XPortal.Store.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.BIND_ENTITY, modelName, entity: item, model });
                    self.TriggerClientEventsForRow(modelName, item, editableColumns);
                    r(item);
                });
            }, async function (state, events, ipromise) {
                var isCompleted = state === null || state.others === null || state.others.length === 0;
                return isCompleted;
            }, "importing-data-entities").then(function (processedItems) {
                updateImportSate(options, { level: 2, type: "exec.clientevents.completed", data: { index: options.processedBatchIndex + 1, amount: context.events.entities.length, errors: context.events.errorsAmount } });
                onOk(context);
            }).catch(function (ex) {
                updateImportSate(options, { level: 2, type: "exec.clientevents.error", data: { index: options.processedBatchIndex + 1, amount: context.events.entities.length, errors: context.events.errorsAmount, error: ex } });
                context.events.isValid = false;
                context.events.error = ex;
                onOk(context);
            });
        });
    };
    function saveProcessedRecords(options, context, model) {
        var kgrid = options.grid.data("kendoGrid");
        var entities = (options.skipGridFromPipeLine) ? context.insert.entities : kgrid.dataSource.data();
        updateImportSate(options, { level: 2, type: "exec.saverecords.start", data: { index: options.processedBatchIndex + 1, amount: (entities || []).length } });
        context.save = { isValid: true, entities: [], errors: [], errorsAmount: 0 };
        return new Promise(function (onOk) {
            var storeModel = XPortal.Store.GetModelByName(XPortal.Store.getGridModelName(options.grid.attr("id")));
            for (var k = 0; k < entities.length; k++) {
                updateImportSate(options, { level: 3, type: "validaterow", data: { index: k, batchindex: options.processedBatchIndex + 1, entity: entities[k] } });
                if (validateEntity(options, entities[k], context, context.save, k)) {
                    XPortal.Store.SetItemToSave(storeModel, entities[k], model.NodeId, false);
                    context.save.entities.push(entities[k]);
                }
            }
            XPortal.Store.SaveStoreItemsDefer(true, true).then(function (saveResult) {
                var errors = (saveResult || []).filter(function (x) { return x.rejected ? true : false; }).map(function (x) {
                    var id = XPortal.Template.GetObjPropValueByName(x.rejected[0], "UniqueId");
                    context.save.errors[id] = { field: "", error: ((x.rejected[1] || {}).Errors || []).join() };
                    context.save.errors[id].rowindex = XPortal.Template.GetObjPropValueByName(x, "importrowindex");
                    return id;
                });
                context.save.entities = context.save.entities.filter(function (x) {
                    var id = XPortal.Template.GetObjPropValueByName(x, "UniqueId");
                    return context.save.errors[id] ? false : true;
                });
                context.save.errorsAmount = errors.length;
                context.save.isValid = context.save.errorsAmount < 1;
                updateImportSate(options, { level: 2, type: "exec.saverecords.completed", data: { index: options.processedBatchIndex + 1, amount: (entities || []).length } });
                onOk(context);
            }).catch(function (ex) {
                updateImportSate(options, { level: 2, type: "exec.saverecords.error", data: { index: options.processedBatchIndex + 1, amount: entities.length, errors: context.save.errorsAmount, error: ex } });
                context.save.isValid = false;
                context.save.error = ex;
                onOk(context);
            });
        });
    };

    function ensureImportResponse(options, response) {
        var result = response;
        if (response.BatchSize && response.BatchSize > 0) options.batchSize = response.BatchSize;
        else options.batchSize = options.batchSize > 0 ? options.batchSize : options.grid.data("kendoGrid").dataSource.pageSize();
        if (response.Item) {
            var itemContext = XPortal.Grid.MapEntity(response.Item);
            result.ImportDataId = XPortal.Template.GetObjPropValueByName(itemContext, "uniqueid");
            result.TotalRowsCount = XPortal.Template.GetObjPropValueByName(itemContext, "FileRowsCount");
            result.FieldsToProcess = (XPortal.Template.GetObjPropValueByName(itemContext, "filefieldstoprocess") || "").split("#|#");
            result.NodeId = (XPortal.Template.GetObjPropValueByName(itemContext, "filefieldstoprocess") || "").split("#|#");
        }
        return result;
    }
    function cleanUpGrid(options, importContainer) {
        var modelName = XPortal.Store.getGridModelName(options.grid.attr("id"));
        var storeModel = XPortal.Store.GetModelByName(modelName);
        XPortal.Store.ClearItemToSave(storeModel);
        var kgrid = options.grid.data("kendoGrid");
        kgrid.dataSource.data([]);
        kgrid.dataSource.read();
    }
    function cleanUpGridBeforeUpdate(options, entities) {
        var grid = options.grid;
        var modelName = XPortal.Store.getGridModelName(grid.attr("id"));
        var gridId = grid.attr("data-id");
        var parentInfo = XPortal.Grid.dictionaryParent[gridId];
        var model = { NodeId: gridId, Alias: grid.attr("entityalias"), IsCreating: false, ParentInfo: parentInfo ? decodeURIComponent(parentInfo) : null };
        var storeModel = XPortal.Store.GetModelByName(modelName);
        XPortal.Store.ClearItemToSave(storeModel);
        var kgrid = grid.data("kendoGrid");
        kgrid.dataSource.data([]);
        if (options.skipGridFromPipeLine) kgrid.dataSource.read();
        return model;
    };
    function validateEntity(options, preparedEntity, context, validationContext, index) {
        var kgrid = options.grid.data("kendoGrid");
        var entityToValidate = getGridEntity(options, kgrid, preparedEntity) || preparedEntity;
        validationResult = XPortal.GridInlineEditing.ValidateInlineEditors([{ inUse: false, added: new Date(), entity: entityToValidate, nodeId: kgrid.options.pageData.nodeId, updateGrid: false }], true, true);
        var isValid = validationContext.isValid = validationResult.length > 0;
        if (!isValid) {
            var k = XPortal.Template.GetObjPropValueByName(preparedEntity, "uniqueid");
            validationContext.errorsAmount = validationContext.errorsAmount + 1;
            validationContext.errors[k] = entityToValidate.validationResults.summaryDetails;
            validationContext.errors[k].rowindex = XPortal.Template.GetObjPropValueByName(preparedEntity, "importrowindex");
            updateImportSate(options, { level: 3, type: "validaterow.error", data: { index: index + 1, error: (validationContext.errors[k] || []).map(function (v) { return v.field ? "" + v.field + "> " + v.error : ""; }).join("; "), entity: entityToValidate } });
        }
        return isValid;
    }
    function updateGridProcessingState(context) {
        context.EntitiesToFinalize = context.save.entities.map(function (x) { return { uniqueid: XPortal.Template.GetObjPropValueByName(x, "uniqueid"), rowindex: XPortal.Template.GetObjPropValueByName(x, "importrowindex") }; });
        context.EntitiesWithErrors = [];
        for (var i in context.save.errors) {
            var errors = context.save.errors[i];
            errors = Array.isArray(errors) ? errors : [errors];
            var rowindex = errors.rowindex;
            delete errors.rowindex;
            context.EntitiesWithErrors.push({ uniqueId: i, rowindex, errors });
        }
        return context;
    }
    function getGridEntity(options, kgrid, entity) {
        if (options.skipGridFromPipeLine) return entity;
        var euid = XPortal.Template.GetObjPropValueByName(entity, "uniqueid");
        var resi = kgrid.dataSource.data().find(function (di) {
            return XPortal.Template.GetObjPropValueByName(di, "uniqueid") == euid;
        });
        return resi;
    }
    function initReportGrid(options, popupObj, onExtraFitler) {
        return new Promise(function (onOk) {
            //find source grid in popup and wait for the data to be loaded
            if (options.reportGridId > 0) {
                var reportXgrid = $(popupObj.find('.grid-parent .entity-grid').filter(function (ix, x) {
                    return $(x).attr("data-id") == options.reportGridId;
                }));
                if (reportXgrid.length) XPortal.Grid.PreInit(reportXgrid.closest(".modal-content"));
                reportXgrid.on("grid.beforeRequest", function (e, g, r) {
                    r.filter = r.filter || {};
                    r.filter.filters = r.filter.filters || [];
                    r.filter.filters.push({ field: "importid", logic: "And", operator: "eq", value: (options.importDataId || "").replaceAll("-", "").toLowerCase() });
                    if (onExtraFitler) onExtraFitler(popupObj, options, r, "before");
                });
                reportXgrid.on("grid.afterRequest", function (e, g, r, items, d) {
                    if (onExtraFitler) onExtraFitler(popupObj, options, r, "after", d, items);
                });
                XPortal.Utils.waitFor(function () {
                    var mbox = reportXgrid.data("kendoGrid");
                    if (!mbox) return false;
                    XPortal.Dashboard.Init(reportXgrid.closest(".grid-parent"));
                    onOk(options.reportGrid = reportXgrid);
                    return true;
                }, XPortal.Utils.waitFor);
            } else {
                console.warn("there is no setting for report grid!!!", { gridid: options.reportGridId, options, popupObj });
                onOk(options.reportGrid);
            }
        });
    };
    function getNextDistincEntity(items, processed) {
        //it should always be unique collection, because server should care about it...othewise could be an issue to correctly process items
        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            var iuid = XPortal.Template.GetObjPropValueByName(item, "uniqueid");
            if (!processed.find(function (x) { return x == iuid; })) {
                processed.push(iuid);
                return item;
            }
        }
        return null;
    };
    function updateImportSate(options, state) {
        setTimeout(function () {
            var s = options.state = options.state || {};
            var msg = "";
            s[state.level] = s[state.level] || {};
            s[state.level].type = state.type;
            s[state.level].data = state.data;
            if (state.level < 3) log(-1, ' ' + new Array(2 * state.level + 1).join('-') + ' ' + (msg = s[state.level].message = getStateMessage(options, state.type, state.data)));
            if (s.container === false) return;
            if (!s.container) s.container = $(options.modalSelector).find(".import-data-step3-more");
            if (!s.container.length) return s.container = false;
            if (!s.containerl1) s.containerl1 = s.container.find(".level1");
            if (!s.containerl2) s.containerl2 = s.container.find(".level2");
            if (!s.containerl3) s.containerl3 = s.container.find(".level3");
            if (!s.containerl3.length) s.containerl3 = false;
            if (!s.containerl2.length) s.containerl2 = false;
            if (!s.containerl1.length) s.containerl1 = false;

            if (state.level === 3 && s.containerl3 !== false) s.containerl3.html(msg || getStateMessage(options, state.type, state.data));
            if (state.level === 2 && s.containerl2 !== false) s.containerl2.html(msg || getStateMessage(options, state.type, state.data));
            if (state.level === 1 && s.containerl1 !== false) s.containerl1.html(msg || getStateMessage(options, state.type, state.data));

        }, 1);
    };
    function getStateMessage(options, mType, mData) {
        var dictionaryKeyPrefix = ((options.settings || {}).dictionaryKeyPrefix || "XFGrid.Command.Import.") + "State.";
        var lkey = dictionaryKeyPrefix + mType;
        var msg = XPortal.Localization.GetCachedString(lkey) || getDefaultMessageFor(mType);
        return XPortal.Template.ReplaceFormatString(msg, null, mData, {});
    };
    function getDefaultMessageFor(lkey) {
        if (lkey == "uploadfile.start") return " file is uploading to server";
        if (lkey == "uploadfile.error") return " critical eror - can't upload file";
        if (lkey == "uploadfile.completed") return " file has been uploaded. there are [[totalrowscount]]rows,batches:[[totalbatchcount]],context:[[importdataid]]";

        if (lkey == "process.batch.start") return " [[index]] - start processing new batch";
        if (lkey == "process.batch.completed") return " [[index]] - finished(batch of rows-[[amount]])";
        if (lkey == "process.batch.finalizing") return " [[index]] - finalizing(batch of rows-[[amount]])";
        if (lkey == "process.batch.error") return "error processing batch: [[index]]";

        if (lkey == "insertrows.start") return " [[index]] - start inserting rows";
        if (lkey == "insertrow") return "insert row: [[index]]";
        if (lkey == "insertrow.error") return "error for row: [[index]]";
        if (lkey == "validaterow") return "validation row: [[index]]";
        if (lkey == "validaterow.error") return "[[batchindex]] validation error: [[index]] - [[error]]";
        if (lkey == "insertrows.completed") return " [[index]] - finished(inserting rows:[[amount]])";

        if (lkey == "exec.clientevents.start") return " [[index]] - update rows data";
        if (lkey == "exec.clientevents.completed") return " [[index]] - finished(update rows data:[[amount]])";
        if (lkey == "exec.clientevents.row") return " update row data [[index]]";
        if (lkey == "exec.clientevents.error") return " error! update row data [[index]] [[error]]";

        if (lkey == "exec.saverecords.start") return " [[index]] - saving rows data";
        if (lkey == "exec.saverecords.completed") return " [[index]] - finished(save rows data:[[amount]])";
        if (lkey == "exec.saverecords.error") return " error! save rows data [[index]] [[error]]";

        return lkey;
    }
    function loadLocalizationMessages() {
        var localizedKeys = [
            "uploadfile.start", "uploadfile.error", "uploadfile.completed",
            "process.batch.start", "process.batch.completed", "process.batch.error", "process.batch.finalizing",
            "insertrows.start", "insertrow", "insertrow.error", "validaterow", "validaterow.error", "insertrows.completed",
            "exec.clientevents.start", "exec.clientevents.error", "exec.clientevents.completed", "exec.clientevents.row",
            "exec.saverecords.start", "exec.saverecords.completed", "exec.saverecords.error"
        ];

        for (var i = 0; i < localizedKeys.length; i++)
            localizedKeys[i] = "XFGrid.Command.Import.State." + localizedKeys[i];
        return new Promise(function (onOk) {
            XPortal.Localization.GetLocalizedStrings(localizedKeys)
                .then(function () { setTimeout(onOk, 1); }, function () { setTimeout(onOk, 1); })
                .catch(function () { setTimeout(onOk, 1); });
        });
    };
    function log(iscritical, msg, ...args) {
        if (!console) return;
        args = args.length > 0 ? (args.length == 1 ? args[0] : args) : null;
        if (iscritical > 0) return args ? console.error(msg, args) : console.error(msg);
        if (iscritical == 0) return args ? console.warn(msg, args) : console.warn(msg);
        return args ? console.log(msg, args) : console.log(msg);
    };
    function ShowReportGrid(stepContainer, options) {
        stepContainer.find(".import-report").addClass("d-none").hide();
        stepContainer.find(".import-report-hide").removeClass("d-none").show();
        stepContainer.find(".import-data-summary-short").addClass("d-none").hide();
        options.reportGrid.data("kendoGrid").dataSource.read().then(
            function () {
                stepContainer.find(".rprt-grid-container").show().removeClass("d-none");
                XPortal.DropdownBtns.gridButtons.check($(".rprt-grid-container"));
            }
        );
        let reportGrid = options.reportGrid;
        if (reportGrid != null) {
            reportGrid.find(".k-pager-wrap").removeClass("k-pager-sm");
            reportGrid.find(".k-pager-wrap").addClass("k-pager-md");
        }
    };

    return self;
}());




